import IntegrationCell from './components/IntegrationCell';
import { ActionsCell, DateCell, StatusCell, TextCell } from './components/IntegrationTableCells';
import {
    INACTIVE_REQUEST_STATUSES,
    PARTNERS_INFORMATION_FEATURE_NAME,
    FORM_TYPES,
    REQUEST_TYPES,
    STATUSES,
} from './consts';

export const getStatusForType = (requests, type) => {
    const request = requests.find(r => r.request_type === type);
    if (!request) {
        return { status: STATUSES.NOT_STARTED, request: null };
    }
    return { status: request.status, request };
};

export const formatDate = dateStr => {
    if (!dateStr) return null;
    const date = new Date(dateStr);

    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const isAdMonType = type => type === REQUEST_TYPES.AD_MONETIZATION;
export const isFormType = type => FORM_TYPES.includes(type);
const isActiveRequest = request => !INACTIVE_REQUEST_STATUSES.includes(request.status);

export const isRequestDisabled = ({ requests, type, status }) => {
    const hasActiveAdMonExclusive = requests.some(
        request => !isAdMonType(request.request_type) && isActiveRequest(request)
    );
    const hasActiveAdMon = requests.some(
        request => request.request_type === REQUEST_TYPES.AD_MONETIZATION && isActiveRequest(request)
    );
    const isTypeBlocked = (isAdMonType(type) && hasActiveAdMonExclusive) || (!isAdMonType(type) && hasActiveAdMon);

    return isTypeBlocked && status === STATUSES.NOT_STARTED;
};

export const isPartnerInfoMissing = navigationSections => {
    if (!navigationSections) return false;
    const partnerInfoElement = navigationSections
        .flatMap(section => section.elements || [])
        .find(({ name }) => name === PARTNERS_INFORMATION_FEATURE_NAME);
    return !!partnerInfoElement?.missing_info;
};

export const getIntegrationTableMetadata = ({ translatePrefix, adminMode = false }) => {
    const columns = [
        {
            name: 'integration',
            displayName: `${translatePrefix}.TABLE_HEADERS.INTEGRATION`,
            cellComponent: IntegrationCell,
        },
        {
            name: 'status',
            displayName: `${translatePrefix}.TABLE_HEADERS.STATUS`,
            cellComponent: StatusCell,
            headerWidth: '140px',
        },
        {
            name: 'lastEdited',
            displayName: `${translatePrefix}.TABLE_HEADERS.LAST_EDITED`,
            cellComponent: DateCell,
            headerWidth: '140px',
        },
    ];

    if (adminMode) {
        columns.push(
            {
                name: 'submittedAt',
                displayName: `${translatePrefix}.TABLE_HEADERS.SUBMITTED_AT`,
                cellComponent: DateCell,
                headerWidth: '140px',
            },
            {
                name: 'reviewer',
                displayName: `${translatePrefix}.TABLE_HEADERS.REVIEWER`,
                cellComponent: TextCell,
                headerWidth: '150px',
            },
            {
                name: 'reviewerComments',
                displayName: `${translatePrefix}.TABLE_HEADERS.REVIEWER_COMMENTS`,
                cellComponent: TextCell,
                headerWidth: '200px',
            }
        );
    }

    columns.push({
        name: 'actions',
        displayName: `${translatePrefix}.TABLE_HEADERS.ACTIONS`,
        cellComponent: ActionsCell,
        headerAlign: 'right',
        headerWidth: '220px',
    });

    return columns;
};
